<template>
  <div>
    <b-container class="mt-5 pt-5">
      <b-row align-h="center">
        <b-col md="6">
          <h1>Login</h1>
          <hr />
          <b-alert show variant="warning">
            Access to this application is limited to authorized staff. To grant
            permission to a new staff member, please contact us via the
            <b-link href="mailto:ofdit@sps.cuny.edu" class="alert-link">
              OFDIT admin email account.</b-link
            >
          </b-alert>
          <b-form @submit="onSubmit" @reset="onReset" v-if="show">
            <b-form-group
              id="login-group-1"
              label="Your CUNY/SPS username:"
              label-for="login-1"
            >
              <b-input-group append="@cuny.edu">
                <b-form-input
                  id="input-1"
                  v-model="form.username"
                  required
                  placeholder="Please enter your desktop username"
                ></b-form-input>
              </b-input-group>
            </b-form-group>

            <b-form-group
              id="login-group-2"
              label="Your CUNY/SPS password:"
              label-for="password"
            >
              <b-form-input
                id="password"
                v-model="form.password"
                type="password"
                required
                placeholder="Please enter your desktop password"
              ></b-form-input>
            </b-form-group>
            <b-row align-h="end">
              <b-button class="mx-3" type="reset" variant="secondary"
                >Reset</b-button
              >
              <b-button class="mx-3" type="submit" variant="primary"
                >Login</b-button
              >
            </b-row>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  export default {
    name: 'login',
    components: {},
    data() {
      return {
        form: {
          username: '',
          password: ''
        },
        show: true
      }
    },
    methods: {
      onReset: function(evt) {
        evt.preventDefault()
        this.form.username = ''
        this.form.password = ''
      },
      onSubmit: function(evt) {
        evt.preventDefault()
        this.$store
          .dispatch('login', this.form)
          .then(() => {
            this.$root.$bvToast.toast(
              `You have successfully logged in,
          ${this.currentUser.first_name}.`,
              {
                title: 'Success',
                autoHideDelay: 1000,
                toaster: 'b-toaster-top-center',
                variant: 'success'
              }
            )
            this.$router.push(this.$route.query.redirect || '/')
          })
          .catch(err => {
            this.$bvToast.toast(`${err}`, {
              title: 'Unsuccessful',
              toaster: 'b-toaster-top-center',
              variant: 'danger'
            })
          })
      }
    },
    computed: {
      currentUser() {
        return this.$store.getters.currentUser
      },
      isLoggedIn() {
        return this.$store.state.courseDev.user.isLoggedIn
      }
    }
  }
</script>
